import { computed } from 'mobx';
import React from 'react';

class Watermark extends React.Component {
  render() {
    const { overrideColour } = this.props;

    if (!this.props.includeWatermark) return null;

    const style = overrideColour != null ? { color: overrideColour } : {};

    return (
      <div className="watermark">
        <div style={style} className="watermarkText">
          {this.data}
          {this.type}
        </div>
      </div>
    );
  }

  @computed
  get data() {
    const { watermark, old } = this.props;
    return typeof watermark ? watermark : old;
  }

  @computed
  get type() {
    const { type } = this.props;
    return type === 'Goals' ? '%' : '';
  }
}

export default Watermark;
